var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIconNavDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 11.9849V14.1099C15.5843 14.3072 15.5439 14.5024 15.4649 14.6832C15.3858 14.8639 15.2699 15.0262 15.1246 15.1596C14.9792 15.2929 14.8076 15.3945 14.6207 15.4577C14.4338 15.5209 14.2358 15.5443 14.0393 15.5266C11.8597 15.2897 9.76597 14.5449 7.92643 13.352C6.21497 12.2645 4.76396 10.8134 3.67643 9.10199C2.47933 7.25409 1.73435 5.15019 1.50184 2.96074C1.48414 2.76486 1.50742 2.56744 1.5702 2.38106C1.63297 2.19467 1.73387 2.02339 1.86647 1.87814C1.99907 1.73288 2.16045 1.61683 2.34036 1.53736C2.52027 1.45789 2.71475 1.41676 2.91143 1.41657H5.03643C5.38019 1.41319 5.71345 1.53492 5.97409 1.75907C6.23474 1.98323 6.40498 2.29451 6.45309 2.63491C6.54278 3.31495 6.70912 3.98267 6.94893 4.62532C7.04423 4.87885 7.06485 5.15439 7.00836 5.41928C6.95187 5.68417 6.82062 5.92732 6.63018 6.11991L5.73059 7.01949C6.73894 8.79283 8.20725 10.2611 9.98059 11.2695L10.8802 10.3699C11.0728 10.1795 11.3159 10.0482 11.5808 9.99172C11.8457 9.93523 12.1212 9.95585 12.3748 10.0512C13.0174 10.291 13.6851 10.4573 14.3652 10.547C14.7093 10.5955 15.0235 10.7688 15.2481 11.034C15.4728 11.2991 15.5921 11.6375 15.5835 11.9849Z",
    stroke: "#444444",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_2041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconNavDesk);
export default __webpack_public_path__ + "static/media/contact_icon-nav-desk.e8ece9f04139becf4d1a01b6a5cbd059.svg";
export { ForwardRef as ReactComponent };